module.exports = __webpack_public_path__ + "img/myblu-bg.3273b213.svg";